var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app","dark":""}},[_c('notifications',{staticStyle:{"z-index":"1000"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }